import { createContext } from 'react';
import { create } from "mobx-persist";
import UserStore from './UserStore';
import VoterStore from './VoterStore';
import EventStore from './EventStore';
import OrganizationStore from './OrganizationStore';
import ReportStore from './ReportStore';
import MockElectionStore from './MockElectionStore';

const hydrate = create({
    storage: localStorage,
    jsonify: true,
});

class RootStore {
    userStore = new UserStore();
    voterStore = new VoterStore();
    eventStore = new EventStore();
    organizationStore = new OrganizationStore();
    reportStore = new ReportStore();
    mockElectionStore = new MockElectionStore();

    constructor() {
        hydrate("dXNlclN0b3Jl", this.userStore)
        .then(() => {
            console.log("Hydrated Data.")
        })
    }
}


export const RootStoreContext = createContext(new RootStore())